import { combineReducers } from 'redux';
//import user from './user_reducer';
import column_master from './column_master_reducer';

const rootReducer = combineReducers({
  //  user,
    column_master
});

export default rootReducer;